$(function() {
    let $websiteDropDown = $(".ws-distributors-login__website-dropdown");

    $websiteDropDown.on("change",
        function (e) {
            e.preventDefault();

            let $this = $(this);
            
            let $form = $this.closest(".ws-distributors-login");
            let redirectLinks = $form.data("ws-redirect-info");
            let websiteName = $this.val();

            if (websiteName === "ria") {
                window.location.href = $form.data("ws-ria-fee-advisor-link");
                return false;
            }
            
            updateWebsiteReferences(
                $form,
                redirectLinks[websiteName].Urls.LoginUrl,
                redirectLinks[websiteName].Urls.RegisterUrl,
                redirectLinks[websiteName].Urls.ResetUrl,
                redirectLinks[websiteName].UsernameFieldName,
                redirectLinks[websiteName].PasswordFieldName,
                websiteName
            );

            let showExternalLinks = (websiteName === "partner" || websiteName === "portal" || websiteName === "prdcr");
            $form.find(".ws-distributors-login__credentials").toggle(!showExternalLinks);
            $form.find(".ws-distributors-login__external-links").toggle(showExternalLinks);
            $form.find(".ws-distributors-login__terms-of-service").toggle(redirectLinks[websiteName].ShowTermsOfService);
            $form.find(".ws-distributors-login__registration").toggle(!showExternalLinks);
            $form.find(".ws-material-group--submit").toggle(!showExternalLinks);

            resetValidationStyling($form);
        }
    );

    function updateWebsiteReferences($form, loginUrl, registerUrl, helpUrl, usernameFieldName, passwordFieldName, websiteName) {
        $form.find(".ws-distributors-login__username").val("").attr("name", usernameFieldName);
        $form.find(".ws-distributors-login__username-validation").attr("data-valmsg-for", usernameFieldName).children().remove();
        $form.find(".ws-distributors-login__password").val("").attr("name", passwordFieldName);
        $form.find(".ws-distributors-login__password-validation").attr("data-valmsg-for", passwordFieldName).children().remove();

        let $registerLink = $form.find(".ws-distributors-login__register-link");
        let $accountHelpLink = $form.find(".ws-distributors-login__account-help");
        let $externalLoginLink = $form.find(".ws-distributors-login__external-login-link");
        let $externalRegisterLink = $form.find(".ws-distributors-login__external-register-link");

        $accountHelpLink.attr("href", helpUrl);
        $form.attr("action", loginUrl);
        $registerLink.attr("href", registerUrl);
        $externalLoginLink.attr("href", loginUrl);
        $externalRegisterLink.attr("href", registerUrl);

        switch (websiteName) {
            case "prdcr":
                $registerLink.text("Not a registered user? Register Now");
                $accountHelpLink.text("Forgot your password?");
                break;
            case "atrac":
            case "corp":
                $registerLink.text("New User? Setup your online account!");
                $accountHelpLink.text("Forgot your Password or Username?");
                break;
        }
    }

    function resetValidationStyling($form) {
        $form.find(".ws-distributors-login__website-dropdown-validation").removeClass("field-validation-error").addClass("field-validation-valid");

        $form.find(".ws-distributors-login__username").blur();
        $form.find(".ws-distributors-login__username-container").removeClass("ws-material-group--theme_error");
        $form.find(".ws-distributors-login__username-validation").removeClass("field-validation-error").addClass("field-validation-valid").children().remove();
        
        $form.find(".ws-distributors-login__password").blur();
        $form.find(".ws-distributors-login__password-container").removeClass("ws-material-group--theme_error");
        $form.find(".ws-distributors-login__password-validation").removeClass("field-validation-error").addClass("field-validation-valid").children().remove();
    }
});